import React, { Component } from 'react'
import Parent from './Parent'
import Loading from './Loading'
import PropTypes from 'prop-types'
export default class ParentsInformation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      prefixData: [],
      fatherPrefixData: [],
      motherPrefixData: [],
      fatherPrefix: '',
      motherPrefix: '',
      fatherFName: this.props.fatherInfo.RelationFirstName || '',
      motherFName: this.props.motherInfo.RelationFirstName || '',
      fatherMName: this.props.fatherInfo.RelationMiddleName || '',
      motherMName: this.props.motherInfo.RelationMiddleName || '',
      fatherLName: this.props.fatherInfo.RelationLastName || '',
      motherLName: this.props.motherInfo.RelationLastName || '',
      fatherProfession: this.props.fatherInfo.Profession || '',
      motherProfession: this.props.motherInfo.Profession || '',
      fatherCompany: this.props.fatherInfo.Company || '',
      motherCompany: this.props.motherInfo.Company || '',
      fatherCompanyAddress: this.props.fatherInfo.CompanyAddress || '',
      motherCompanyAddress: this.props.motherInfo.CompanyAddress || '',
      fatherPhone: this.props.fatherInfo.MobileNumber || '',
      motherPhone: this.props.motherInfo.MobileNumber || '',
      fatherEmail: this.props.fatherInfo.RelationEmail || '',
      motherEmail: this.props.motherInfo.RelationEmail || '',
      fatherAddress: this.props.fatherInfo.Address || '',
      motherAddress: this.props.motherInfo.Address || '',
      loading: true,
      motherAttendedInstitution: this.props.motherInfo.AttendedInstitution || false,
      fatherAttendedInstitution: this.props.fatherInfo.AttendedInstitution || false,
      error: '',
      fatherDeceased: this.props.fatherInfo.Deceased || false,
      motherDeceased: this.props.motherInfo.Deceased || false
    }
  }

  componentDidMount () {
   
  }

  render () {
    return  <div></div>
  }
}
ParentsInformation.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  fatherInfo: PropTypes.object,
  motherInfo: PropTypes.object,
  collectState: PropTypes.func,
  error: PropTypes.object,
  getDefaultValue: PropTypes.func,
  fatherId: PropTypes.number.isRequired,
  motherId: PropTypes.number.isRequired
}
